// constants
import { ReportActionTypes } from './constants';
import { Report as ReportDataType } from 'src/types/report';

export type ReportActionType = {
    type:
        | ReportActionTypes.API_RESPONSE_SUCCESS
        | ReportActionTypes.API_RESPONSE_ERROR
        | ReportActionTypes.GET_REPORT
        | ReportActionTypes.ADD_REPORT
        | ReportActionTypes.EDIT_REPORT
        | ReportActionTypes.GET_REPORTS
        | ReportActionTypes.GET_VALIDATE_REPORT
        | ReportActionTypes.GET_SERVICE_REPORT
        | ReportActionTypes.GET_SALES_REPORT
        | ReportActionTypes.GET_OBSERVATION_REPORT
        | ReportActionTypes.RESET
        | ReportActionTypes.RESET_SUCCESS
        | ReportActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const reportApiResponseSuccess = (
    actionType: string,
    data: ReportDataType[] | ReportDataType | [] | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): ReportActionType => ({
    type: ReportActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const reportApiResponseError = (
    actionType: string,
    data: ReportDataType[] | ReportDataType | [] | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): ReportActionType => ({
    type: ReportActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addReport = (params: any): ReportActionType => ({
    type: ReportActionTypes.ADD_REPORT,
    payload: params,
});

export const editReport = (params: any): ReportActionType => ({
    type: ReportActionTypes.EDIT_REPORT,
    payload: params,
});

export const getReport = (params: any): ReportActionType => ({
    type: ReportActionTypes.GET_REPORT,
    payload: params,
});

export const getReports = (params: any): ReportActionType => ({
    type: ReportActionTypes.GET_REPORTS,
    payload: params,
});

export const getServiceReports = (params: any): ReportActionType => ({
    type: ReportActionTypes.GET_SERVICE_REPORT,
    payload: params,
});

export const getSalesReports = (params: any): ReportActionType => ({
    type: ReportActionTypes.GET_SALES_REPORT,
    payload: params,
});

export const getValidateReport = (params: any): ReportActionType => ({
    type: ReportActionTypes.GET_VALIDATE_REPORT,
    payload: params,
});

export const getObservationReports = (params: any): ReportActionType => ({
    type: ReportActionTypes.GET_OBSERVATION_REPORT,
    payload: params,
});

export const resetReport = (): ReportActionType => ({
    type: ReportActionTypes.RESET,
    payload: {},
});

export const resetReportSuccess = (): ReportActionType => ({
    type: ReportActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetReportError = (): ReportActionType => ({
    type: ReportActionTypes.RESET_ERROR,
    payload: {},
});
